import { defineStore } from 'pinia'

export const useUIStore = defineStore('ui', {
    state: () => ({
        isMenuOpen: false,
    }),
    actions: {
        setMenuOpen(isOpen) {
            this.isMenuOpen = isOpen
        },
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen
        },
    },
})
